import customOptionsStatusComponent from './custom-options-status.component';

const customOptionsStatusModule = angular.module('customOptionsStatus', [
])
  .component('customOptionsStatus', customOptionsStatusComponent)
  .name;

export default customOptionsStatusModule;
